import { z } from "zod";

import { OnboardingFormAnswerSchema } from "../../../schemas/organization";

export const PostOnboardingFormRequestBodySchema = z.object({
  shopifyPlan: z.string(),
  shopId: z.string(),
  response: OnboardingFormAnswerSchema,
});

export type PostOnboardingFormRequestBodyType = z.infer<
  typeof PostOnboardingFormRequestBodySchema
>;
